import axios from "axios";
import {
    IShippingAndTax,
    IShippingAndTaxEnvelope,
    IShippingAndTaxReturn,
    ShippingAndTaxFormValues
} from "../../models/ShippingAndTax/ShippingAndTax";
import {api, responseBody} from "./apiBase.service";

const ShippingAndTaxes = {
    list: (
        params: URLSearchParams
    ): Promise<IShippingAndTaxEnvelope> =>
        axios.get("/ShippingAndTax", {params: params})
            .then(responseBody),
    byId: (id: string) => api.get(`/ShippingAndTax/${id}`),
    create: (ShippingAndTax: ShippingAndTaxFormValues) =>
        api.post(`/ShippingAndTax/`, ShippingAndTax),
    update: (ShippingAndTax: IShippingAndTax) =>
        api.put(`/ShippingAndTax/${ShippingAndTax.id}`, ShippingAndTax),
    delete: (id: string) =>
        api.del(`ShippingAndTax/${id}`),
    return: (ShipingAndTax: IShippingAndTaxReturn) =>
        api.put(`/ShippingAndTax/${ShipingAndTax.id}/return`, ShipingAndTax),
};

export default ShippingAndTaxes
